// Libraries
import { atom } from "recoil";
// API
import { GetBusinessUnit_businessUnit_farmAnimalTypes } from "api/BusinessUnits/types/GetBusinessUnit";

export interface Species extends GetBusinessUnit_businessUnit_farmAnimalTypes {
  active?: boolean;
}

export const speciesListState = atom<Species[] | undefined>({
  key: "speciesListState",
  default: undefined,
});
